/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Greeting/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Greeting({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/Patient/Details/Greeting"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let editRelationFromPersonRecordGreetingValueData = fromData.useDataValue({ viewPath,
context: 'edit_relation',
path: 'from_person_record.greeting',
})
  return (<React.Fragment
>
<div
  data-testid="Greeting.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-juO5d': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 paddingBottom={dtSpaceXxs}
 text="Greeting"
 weight="semibold"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 paddingBottom={dtSpaceXxs}
 data="edit_relation.from_person_record.greeting"
 text={editRelationFromPersonRecordGreetingValueData}
/>
</div>
{children}
</React.Fragment>)
}